import { CampoAlterado, DadosPendenciaFinalizada } from "./types";
import { parseJsonSafely } from "../../../../../../../utility/jsonUtils";
import { getStatusLabelStatusKanban, getResultadoLabelPendencia } from "../../../../../../../utility/statusPendenciaKanban";

const formatValue = (value: any): string => {
    if (value === null || value === undefined || value === '') return '—';
    if (typeof value === 'boolean') return value ? 'Sim' : 'Não';
    if (typeof value === 'object') return JSON.stringify(value, null, 2);
    return String(value);
};

export const mapearPendenciasFinalizadas = (logs: any[]): DadosPendenciaFinalizada[] => {
    const logsPendencias = logs.filter((log: any) => log?.entidade_nome === 'pendencia');
    
    if (!logsPendencias || logsPendencias.length === 0) {
        return [];
    }

    const pendencias: DadosPendenciaFinalizada[] = [];

    for (const logPendencia of logsPendencias) {
        const dadosAntes = parseJsonSafely(logPendencia.dados_antes);
        const dadosDepois = parseJsonSafely(logPendencia.dados_depois);

        if (!dadosDepois) continue;

        const campos: CampoAlterado[] = [];

        if (dadosDepois.status_kanban && dadosAntes?.status_kanban !== dadosDepois.status_kanban) {
            campos.push({
                campo: 'Status',
                antes: dadosAntes?.status_kanban ? getStatusLabelStatusKanban(dadosAntes.status_kanban) : '—',
                depois: getStatusLabelStatusKanban(dadosDepois.status_kanban)
            });
        }

        if (dadosDepois.resultado && dadosAntes?.resultado !== dadosDepois.resultado) {
            campos.push({
                campo: 'Resultado',
                antes: dadosAntes?.resultado ? getResultadoLabelPendencia(dadosAntes.resultado) : '—',
                depois: getResultadoLabelPendencia(dadosDepois.resultado)
            });
        }

        if (dadosDepois.resposta !== undefined && dadosAntes?.resposta !== dadosDepois.resposta) {
            campos.push({
                campo: 'Resposta',
                antes: formatValue(dadosAntes?.resposta),
                depois: formatValue(dadosDepois.resposta)
            });
        }

        if (dadosDepois.resolvida !== undefined && dadosAntes?.resolvida !== dadosDepois.resolvida) {
            campos.push({
                campo: 'Resolvida',
                antes: formatValue(dadosAntes?.resolvida),
                depois: formatValue(dadosDepois.resolvida)
            });
        }

        if (campos.length > 0) {
            pendencias.push({
                id_pendencia: logPendencia.entidade_id,
                tipo: dadosDepois.tipo || dadosAntes?.tipo || '—',
                descricao: dadosDepois.descricao || dadosAntes?.descricao || null,
                campos
            });
        }
    }

    return pendencias;
};

